import React from 'react';

import styled, { css } from 'styled-components';

import { LazyLoadImage } from 'react-lazy-load-image-component';

const ImageTwoUp = ({ block, className }) => {

  return (
    <Container className={className}>
      <LazyLoadImage src={block.images[0].image[0].url} 
        style={{objectPosition: `${block.images[0].image[0].focalPoint[0] * 100}% ${block.images[0].image[0].focalPoint[1] * 100}%`}}
      />
      <LazyLoadImage src={block.images[1].image[0].url} 
        style={{objectPosition: `${block.images[0].image[0].focalPoint[0] * 100}% ${block.images[0].image[0].focalPoint[1] * 100}%`}}
      />
    </Container>
  )
};


export default ImageTwoUp;

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3em 0;
  img {
    width: 100%;
    height: auto;
    display: block;
    margin: 1em 0;
    
  }
  @media all and (min-width: 850px) {
    flex-direction: row;
    justify-content: space-between;
    img {
      width: 47.5%;
      height: 50vh;
      object-fit: cover;
    }
  }
`;